import { render } from "./upperBar.vue?vue&type=template&id=f715f2c6"
import script from "./upperBar.vue?vue&type=script&lang=js"
export * from "./upperBar.vue?vue&type=script&lang=js"

import "./upperBar.vue?vue&type=style&index=0&id=f715f2c6&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__